import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import ArrayStore from "devextreme/data/array_store";
import { alert, confirm } from 'devextreme/ui/dialog';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../../common/concurrency';
import { MESSAGES } from '../../../../common/Messages';

import {
    Column,
    Selection,
    GroupPanel,
    Lookup,
    DataGrid,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import DropDownButton, {
    Item as DropDownItem
} from 'devextreme-react/drop-down-button';

import axios from "axios";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";

const gridKey = "e355e027-38a9-4523-aa85-ad93d682b687";
function CancelledDetailsTab(props) {
    const dataGrid = props.canceledItemsTabGrid;
    var accessToken = props.oidc.user.access_token;
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const allowedPageSizes = [10, 20, 100, "all"];
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const dataSource = useMemo(() => createStore({
            key: 'rowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/wm/TransactionDetail/GetCancelledDetails`,
            loadParams:
            {
                transactionHeaderRowId: function () {
                    return props.sourceId;
                }
            },
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                };
            }
        }), [props.sourceId]);
    const handleCellValueChanged = (data) => {

        setSelectedItemKeys(data.selectedRowKeys);
    }

    const onOptionItemClick = (e) => {
        switch (e.itemData.text) {
          case 'Reverse Cancel Line Item':
            reverseCancelLineItems();
            break;
          default:
            return;
        }
      }

    const reverseCancelLineItems = () => {

        dataGrid.current.instance().beginCustomLoading("Cancelling");
        axios.post
            (
                `${window._env_.REACT_APP_APIS}/wm/TransactionDetail/ReverseCancelLineItems`,
                selectedItemKeys,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then(() => {
                // A refusal now arrives as a non-2xx and lands in .catch, so reaching here means success.
                dataGrid.current.instance().endCustomLoading();
                dataGrid.current.instance().refresh();

                if(props.detailGrid?.current?.instance)
                {
                    props.detailGrid.current.instance().refresh();
                }
            })
            .catch((err) => {
                dataGrid.current.instance().endCustomLoading();
                // A version conflict is already handled globally by the axios interceptor.
                if (err?.[CONCURRENCY_HANDLED]) {
                    return;
                }
                // Was `alert(err, "Error")`, which rendered the literal text "[object Object]".
                alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
            });

    }
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={dataSource}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                onSelectionChanged={handleCellValueChanged}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Selection mode="multiple" />
                <Sorting visible={true} mode="multiple" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <Export enabled={true} allowExportSelectedData={true} />
                <Paging enabled={true} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter enabled={true} visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <Column dataField="itemCode" caption="Item Code" dataType="string"></Column>
                <Column dataField="lotCode" caption="Lot Code" dataType="string"></Column>
                <Column dataField="inventoryUOMFlag" caption="Trans Unit" dataType="string">
                    <Lookup
                      dataSource={new ArrayStore({
                        data: [
                            { ID: "I", Text: "Inventory Units" },
                            { ID: "H", Text: "Shipments" },
                            { ID: "K", Text: "Packages" },
                            { ID: "K", Text: "Pieces" },
                          ],
                        key: "ID",
                      })}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                </Column>
                <Column
                    caption="Ordered"
                    dataType="number"
                    dataField="quantityOrder"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column
                    caption="Actual"
                    dataField="quantityActual"
                    dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column
                    caption="UOM"
                    dataField="quantityInventoryUOM"
                    dataType="string"
                >
                </Column>
                <Column
                    caption="Inventory"
                    dataField="inventoryUnits"
                    dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column
                    caption="UOM"
                    dataField="inventoryUnitUOM"
                    dataType="string"
                ></Column>
                <Column
                    caption="Amount"
                    dataField="calcAmount"
                    dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                
                <GridToolbar>
                    <GridToolbarItem location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </GridToolbarItem>
                    <GridToolbarItem location="after">
                        <DropDownButton
                            icon="fa fa-cogs"
                            stylingMode="text"
                            dropDownOptions={{ width: 'auto', minWidth: 200 }}
                            onItemClick={onOptionItemClick}
                        >
                            <DropDownItem text="Reverse Cancel Line Item" disabled={!selectedItemKeys?.length}></DropDownItem>
                        </DropDownButton>
                    </GridToolbarItem>
                    <GridToolbarItem name="refreshButton" />
                    <GridToolbarItem name="exportButton" />
                    <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
            </DataGrid>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CancelledDetailsTab);